import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    potential: 1,
    manager: null,
    tour: [],
    completed: false,
    followup: null
  };
};

const state = getDefaultState();

const getters = {
  getField
};

const mutations = {
  updateField,
  clearFilter(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  clearFilter({ commit }) {
    commit("clearFilter");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
